import { render, staticRenderFns } from "./RegistAccountDetail.vue?vue&type=template&id=2d00fa05&scoped=true"
import script from "./RegistAccountDetail.vue?vue&type=script&lang=js"
export * from "./RegistAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./RegistAccountDetail.vue?vue&type=style&index=0&id=2d00fa05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d00fa05",
  null
  
)

export default component.exports